const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api').replace(/\/$/, '');

async function request(path, options = {}) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    credentials: 'include',
    ...options,
    headers: {
      Accept: 'application/json',
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...(options.token ? { Authorization: `Bearer ${options.token}` } : {}),
      ...options.headers
    }
  });
  const body = await response.json().catch(() => null);
  if (!response.ok) {
    const error = new Error(body?.error?.message || 'Unable to complete your request.');
    error.code = body?.error?.code || 'AUTH_REQUEST_FAILED';
    error.details = body?.error?.details || {};
    error.status = response.status;
    throw error;
  }
  return body.data;
}

export function registerCustomer(values) {
  return request('/auth/register', { method: 'POST', body: JSON.stringify(values) });
}

export function loginCustomer(values) {
  return request('/auth/login', { method: 'POST', body: JSON.stringify(values) });
}

export function refreshCustomerSession() {
  return request('/auth/refresh-token', { method: 'POST' });
}

export function logoutCustomer() {
  return request('/auth/logout', { method: 'POST' });
}

export function logoutAllCustomerSessions(token) {
  return request('/auth/logout-all', { method: 'POST', token });
}

export function getCustomerProfile(token) {
  return request('/account/profile', { token });
}

export function updateCustomerProfile(token, values) {
  return request('/account/profile', { method: 'PATCH', token, body: JSON.stringify(values) });
}

export function getCustomerSessions(token) {
  return request('/auth/sessions', { token });
}

export function revokeCustomerSession(token, sessionId) {
  return request(`/auth/sessions/${encodeURIComponent(sessionId)}`, { method: 'DELETE', token });
}

export function requestContactVerification(token, channel) { return request('/auth/verification/request', { method: 'POST', token, body: JSON.stringify({ channel }) }); }
export function verifyContactCode(token, channel, code) { return request('/auth/verification/verify', { method: 'POST', token, body: JSON.stringify({ channel, code }) }); }
export function requestPasswordReset(email) { return request('/auth/forgot-password', { method: 'POST', body: JSON.stringify({ email }) }); }
export function resetPassword(values) { return request('/auth/reset-password', { method: 'POST', body: JSON.stringify(values) }); }
